module.exports = __webpack_public_path__ + "img/download-black.96ab5a11.svg";